import Supermarket from '@/components/supermarket/supermarket'
import Scansm from '@/components/supermarket/scans'
import Scankanban from '@/components/andon/scans'
import ScanKanbanWorkstation from '@/components/andon/ScanKanbanWorkstation'
import Ranking from '@/components/andon/Ranking'
import RankingABC from '@/components/andon/RankingABC'
import Scankanbanreference from '@/components/andon/scans_reference'
// import Picking from '@/components/picking/picking'
import Oee from '@/components/oee/oee'
import AndonKanban from '@/components/andon/andon_kanban'
import AnalyseAndonKanban from '@/components/andon/AnalyseAndonKanban'
import LoopOperations from '@/components/settings/LoopOperations.vue'
import LoopInfosUpdate from '@/components/loops/LoopInfosUpdate.vue'
import Errors from '@/components/settings/errors'
import AndonAtelier from '@/components/andon/andon_atelier.vue'
import ScanTaktCell from '@/components/andon/scan_takt_cell.vue'
import HenjukaSupply from '@/components/andon/henjuka_supply.vue'
import KanbanBe from '@/components/andon/KanbanBe.vue'
import AndonReference from '@/components/andon/detailed/andon_reference.vue'
import AndonInternalReference from '@/components/andon/intern_hippo/internal_hippodrome.vue'
import ListReferences from '@/components/supply/ListReferences.vue'
import ExternalLoopRefList from '@/components/supply/ExternalLoopRefList.vue'
import InternalLoopRefList from '@/components/supply/InternalLoopRefList.vue'
import TradingLoopRefList from '@/components/supply/TradingLoopRefList.vue'
import ExternalLoopGeneralOverview from '@/components/supply/ExternalLoopGeneralOverview.vue'
import InternalLoopGeneralOverview from '@/components/supply/InternalLoopGeneralOverview.vue'
import UpdateCardInfos from '@/components/supply/UpdateCardInfos.vue'
import ExternalLoopKanbanList from '@/components/supply/ExternalLoopKanbanList.vue'
import InternalLoopKanbanList from '@/components/supply/InternalLoopKanbanList.vue'
import KanbanReferenceModal from '@/components/kanban/KanbanReferenceModal.vue'
import AndonNotReceived from '@/components/andon/andon_not_received.vue'
import LoginPage from '@/pages/login/LoginPage.vue'
import Logout from '@/pages/logout/Logout.vue'
import ProductAndonMethod from '@/components/andon/ProductAndonMethod.vue'
import KanbanLTHistory from '@/components/graph/KanbanLTHistory.vue'
import Vue from 'vue'
import Router from 'vue-router'

import ReferenceDocumentLoop from '@/components/document/ReferenceDocumentLoop.vue'
import GraphReference from '@/components/graph/GraphReference.vue'
import NewHippodrome from '@/components/NewHippodrome.vue'
import TrackingOrder from '@/components/document/Tracking.vue'
import DocumentCreation from '@/components/document/DocumentCreation.vue'
import BoardDocument from '@/components/document/BoardDocument.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/flux',
            name: 'Flux',
            component: NewHippodrome,
        },
        // {
        //   path: '/supermarket',
        //   name: 'supermarket',
        //   component: Supermarket
        // },
        {
            path: '/',
            name: 'andonkanbanhome',
            component: AndonKanban
        },
        {
            name: 'analyseAndonKanban',
            path: '/analyse_andon_kanban',
            component: AnalyseAndonKanban
        },
        {
            name: 'loopOperation',
            path: '/loop_operation',
            component: LoopOperations
        },
        {
            name: 'login',
            path: '/login',
            component: LoginPage
        },
        {
            name: 'loginToken',
            path: '/login/:token*',
            component: LoginPage
        },
        {
            name: 'Logout',
            path: '/logout',
            component: Logout,
        },
        {
            path: '/loop_supply_external/:filter?',
            name: 'external_references',
            component: ExternalLoopRefList
        },
        {
            path: '/loop_supply_external_general',
            name: 'external_overview',
            component: ExternalLoopGeneralOverview
        },
        {
            path: '/loop_supply_internal_general',
            name: 'internal_overview',
            component: InternalLoopGeneralOverview
        },
        {
            path: '/loop_supply_internal/:filter?',
            name: 'internal_references',
            component: InternalLoopRefList
        },
        {
            path: '/loop_trading/:filter?',
            name: 'trading_references',
            component: TradingLoopRefList
        },
        {
            path: '/loop_supply_cards_external',
            name: 'external_cards',
            component: ExternalLoopKanbanList
        },
        {
            path: '/loop_supply_cards_internal',
            name: 'internal_cards',
            component: InternalLoopKanbanList
        },
        {
            path: '/oee',
            name: 'oee',
            component: Oee
        },
        {
            path: '/scankanban/:step/:filter?',
            name: 'scankanban',
            component: Scankanban,
            props: { title: 'Scan Kanban' }
        },
        {
            path: '/scankanbanworkstation/:code?',
            name: 'scankanbanworkstation',
            component: ScanKanbanWorkstation
        },
        {
            path: '/update_card_infos/:reference',
            name: 'updatecardinfos',
            component: UpdateCardInfos
        },
        {
            path: '/andonkanban/:step?',
            name: 'andonkanban',
            component: AndonKanban
        },
        {
            path: '/scankanban/:step/:filter',
            name: 'scankanbanfiltered',
            component: Scankanban,
            props: { title: 'Scan Kanban' }
        },
        {
            path: '/scankanbanreference/:action',
            name: 'Scankanbanreference',
            component: Scankanbanreference,
            props: { title: 'Scan Kanban Reference' }
        },
        {
            path: '/reception/historique-lead-time',
            name: 'historique-lead-time',
            component: KanbanLTHistory,
            props: { title: 'Lead Time Graph' }
        },
        {
            path: '/scansm/:id_kanban',
            name: 'scansm',
            component: Scansm,
            props: { title: 'Scans' }
        },
        {
            path: '/errors/',
            name: 'errors',
            component: Errors,
            props: { title: 'Erreurs' }
        },
        {
            path: '/references',
            name: 'references',
            component: ListReferences,
            props: { title: 'ListReferences' }
        },
        {
            path: '/andon/:reference',
            name: 'andon_reference',
            component: AndonReference,
            props: {}
        },
        {
            path: '/andon_internal/:reference',
            name: 'andon_internal_reference',
            component: AndonInternalReference,
            props: {}
        },
        {
            path: '/ranking',
            name: 'ranking',
            component: Ranking
        },
        {
            path: '/ranking_ABC',
            name: 'RankingABC',
            component: RankingABC
        },
        {
            path: '/references/:action/:reference?',
            name: 'KanbanReferenceModal',
            component: KanbanReferenceModal
        },
        {
            path: '/loop/update/:loop?',
            name: 'LoopInfosUpdate',
            component: LoopInfosUpdate
        },
        {
            path: '/andons_not_received',
            name: 'AndonNotReceived',
            component: AndonNotReceived
        },
        {
            path: '/andonatelier/',
            name: 'andonatelier',
            component: AndonAtelier,
            props: { title: 'Andonatelier' }
        },
        {
            path: '/scan_takt_cell/',
            name: 'scanTaktCell',
            component: ScanTaktCell
        },
        {
            path: '/henjuka_supply/',
            name: 'henjukaSupply',
            component: HenjukaSupply
        },
        {
            path: '/kanban_be/',
            name: 'kanbanBe',
            component: KanbanBe
        },
        {
            path: '/wpm_reference',
            name: 'ProductAndonMethod',
            component: ProductAndonMethod
        },
        {
            path: '/reference_document/:flux',
            name: 'referenceDocumentLoop',
            component: ReferenceDocumentLoop,
        },
        {
            path: '/graph_reference',
            name: 'GraphReference',
            component: GraphReference,
        },
        {
            path: '/tracking_order/:document_id?',
            name: 'TrackingOrder',
            component: TrackingOrder,
        },
        {
            path: '/create_order',
            name: 'DocumentCreation',
            component: DocumentCreation,
        },
        {
            path: '/scans_stats_board',
            name: 'TableauPilotage',
            component: BoardDocument,
        },
        {
            path: '*',
            redirect: '/',
        },
    ]
})

export const whiteList = ['/login']


// WEBPACK FOOTER //
// ./src/app/router/router.js